import axios from "axios";
import moment from "moment";

export const getCollaboratorCapacity = (id, label, year) => {
  const requestUrl = `/team/collaborators_setting`;
  let filter = [];
  if (label && label.length > 0) {
    filter.push({
      property: "label",
      value: label,
      operator: "like"
    });
  }

  let params = {
    organization: id,
    filter: filter,
    year: year ? year : moment().year()
  };
  return axios.get(requestUrl, {
    params
  });
};

export const getCollaborator = ({ organization, id, uid, erpId = null }) => {
  const requestUrl = `/team/collaborator`;

  let params = {
    organization: organization,
    uid: uid,
    id: id,
    erpId: erpId
  };

  return axios.get(requestUrl, {
    params
  });
};

export const getCollaboratorSettingSuggestions = id => {
  const requestUrl = `/team/collaborators_setting/suggestions`;
  let params = { organization: id };

  return axios.get(requestUrl, {
    params
  });
};

export const updateSettingsCollaborator = ({
  organization,
  id,
  bu,
  zone,
  role,
  regime,
  backup,
  profile,
  partner,
  nfSpecialProject,
  arrivalDate,
  departureDate,
  workingHours,
  isOfficeWorkPlace,
  openDays,
  holidayTypes,
  year,
  admin,
  nbrOfRecoveredAnnualHolidays
}) => {
  const requestUrl = `/team/collaborators_setting/edit`;
  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("id", id);
  formData.append("year", year ? year : moment().year());
  bu && formData.append("bu", bu);
  zone && formData.append("zone", zone);
  role && formData.append("role", role);
  backup && formData.append("backup", JSON.stringify(backup));
  regime && formData.append("regime", regime);
  profile && formData.append("profile", profile);
  partner && formData.append("partner", partner);
  admin && formData.append("admin", admin);
  workingHours && formData.append("workingHrMo", workingHours.monday);
  workingHours && formData.append("workingHrTu", workingHours.tuesday);
  workingHours && formData.append("workingHrWe", workingHours.wednesday);
  workingHours && formData.append("workingHrTh", workingHours.thursday);
  workingHours && formData.append("workingHrFr", workingHours.friday);
  isOfficeWorkPlace &&
    formData.append("isOfficeWorkPlace", JSON.stringify(isOfficeWorkPlace));
  openDays && formData.append("openDays", openDays);
  holidayTypes && formData.append("holidayTypes", JSON.stringify(holidayTypes));
  nfSpecialProject && formData.append("specialProject", nfSpecialProject);
  arrivalDate &&
    formData.append(
      "arrivalDate",
      arrivalDate instanceof Date
        ? arrivalDate.format("Y-MM-DDTH:mm:ss")
        : arrivalDate
    );
  departureDate &&
    formData.append(
      "departureDate",
      departureDate instanceof Date
        ? departureDate.format("Y-MM-DDTH:mm:ss")
        : departureDate
    );
  nbrOfRecoveredAnnualHolidays &&
    formData.append(
      "nbrOfRecoveredAnnualHolidays",
      nbrOfRecoveredAnnualHolidays
    );

  return axios.post(requestUrl, formData);
};

export const deleteCollaboratorRegime = ({ organization, id }) => {
  const requestUrl = `/team/collaborators_setting/regime/remove`;

  let formData = new FormData();
  formData.append("id", id);
  formData.append("organization", organization);

  return axios.post(requestUrl, formData);
};

export const saveCollaboratorRegime = ({ organization, regime, hrForDay }) => {
  const requestUrl = `/team/collaborators_setting/regime/save`;
  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("regime", JSON.stringify(regime));
  formData.append("hrForDay", hrForDay);

  return axios.post(requestUrl, formData);
};

export const deleteCollaboratorRole = ({ organization, id }) => {
  const requestUrl = `/team/collaborators_setting/role/remove`;

  let formData = new FormData();
  formData.append("id", id);
  formData.append("organization", organization);

  return axios.post(requestUrl, formData);
};

export const deleteCollaboratorZone = ({ organization, id }) => {
  const requestUrl = `/team/collaborators_setting/zone/remove`;

  let formData = new FormData();
  formData.append("id", id);
  formData.append("organization", organization);

  return axios.post(requestUrl, formData);
};

export const deleteCollaboratorBu = ({ organization, id }) => {
  const requestUrl = `/team/collaborators_setting/bu/remove`;

  let formData = new FormData();
  formData.append("id", id);
  formData.append("organization", organization);

  return axios.post(requestUrl, formData);
};

export const deleteCollaboratorHolidayType = ({
  organization,
  isForced,
  id
}) => {
  const requestUrl = `/team/collaborators_setting/holiday_type/remove`;

  let formData = new FormData();
  formData.append("id", id);
  formData.append("isForced", isForced);
  formData.append("organization", organization);

  return axios.post(requestUrl, formData);
};

export const saveCollaboratorRole = ({ organization, role }) => {
  const requestUrl = `/team/collaborators_setting/role/save`;
  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("role", JSON.stringify(role));

  return axios.post(requestUrl, formData);
};

export const saveCollaboratorZone = ({ organization, zone }) => {
  const requestUrl = `/team/collaborators_setting/zone/save`;
  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("zone", JSON.stringify(zone));

  return axios.post(requestUrl, formData);
};

export const saveCollaboratorBu = ({ organization, bu }) => {
  const requestUrl = `/team/collaborators_setting/bu/save`;
  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("bu", JSON.stringify(bu));

  return axios.post(requestUrl, formData);
};

export const saveCollaboratorHolidayType = ({ organization, holidayType }) => {
  const requestUrl = `/team/collaborators_setting/holiday_type/save`;
  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("holidayType", JSON.stringify(holidayType));

  return axios.post(requestUrl, formData);
};

export const getCollaboratorValuation = (
  organizationId,
  collaboratorErpId,
  collaboratorUid,
  date,
  period
) => {
  const requestUrl = `/team/collaborator/valuation`;
  let params = {
    organization: organizationId,
    collaboratorErp: collaboratorErpId,
    collaboratorUid: collaboratorUid,
    date: date ? date.format("Y-MM-DDTH:mm:ss") : date,
    period: period
  };

  return axios.get(requestUrl, { params });
};

export const getCollaboratorAvatars = id => {
  const requestUrl = `/team/collaborator/avatars`;
  let params = { organization: id };

  return axios.get(requestUrl, {
    params
  });
};

export const getDynamicTableCollaborators = (id, year) => {
  const requestUrl = `/team/collaborator/dynamic_table`;
  let params = {
    organizationId: id,
    year,
    squads: [],
    zones: []
  };

  return axios.get(requestUrl, {
    params
  });
};

export const getPerformanceFolderStatistics = (uid, organizationId) => {
  const requestUrl = `/team/collaborator/performances/selection`;
  let params = {
    uid,
    organization: organizationId
  };
  return axios.get(requestUrl, {
    params
  });
};

export const fetchPerformanceChartStatisticsByUser = (
  organizationId,
  adminisId,
  uid,
  period,
  date
) => {
  const requestUrl = `/team/collaborator/performances/progression`;
  let params = {
    collaboratorUid: uid,
    organization: organizationId,
    date: date ? date.format("Y-MM-DDTH:mm:ss") : date,
    period,
    collaboratorErp: adminisId
  };
  return axios.get(requestUrl, {
    params
  });
};

export const fetchUserScore = (
  organizationId,
  adminisId,
  uid,
  period,
  date
) => {
  const requestUrl = `/team/collaborator/score`;
  let params = {
    collaboratorUid: uid,
    organization: organizationId,
    date: date ? date.format("Y-MM-DDTH:mm:ss") : date,
    period,
    collaboratorErp: adminisId
  };
  return axios.get(requestUrl, {
    params
  });
};

export const getCollaboratorCapacityPlaningChart = (
  idOrganization,
  uidCollaborator,
  erpId,
  period,
  year,
  isCumulate,
  date
) => {
  const requestUrl = `/team/collaborator_capacity_planing`;
  let params = {
    organizationId: idOrganization,
    date: date ? date.format("YYYY-MM-DD") : null,
    year: year,
    collaborator: uidCollaborator,
    erpId: erpId,
    isCumulate: isCumulate,
    period: period
  };
  return axios.get(requestUrl, {
    params
  });
};

export const getGdNotifications = id => {
  const requestUrl = `/team/collaborator/gd_notifications`;
  let params = {
    organizationId: id
  };

  return axios.get(requestUrl, {
    params
  });
};



// WEBPACK FOOTER //
// ./src/api/collaborator.js